import React from 'react';

import { type BaseSvgProps, colorToHexCode, sizeToSvgWidth } from '../../utils';

export const IncomeLine = ({
  'data-testid': testId,
  width = sizeToSvgWidth.fnormal,
  primaryColorHexCode = colorToHexCode['income-blue'],
  backgroundColorHexCode = colorToHexCode.white,
}: BaseSvgProps) => (
  <svg
    width={width}
    height={width}
    className="shrink-0"
    data-testid={testId}
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.573975"
      y="0.5"
      width="12"
      height="12"
      rx="6"
      fill={backgroundColorHexCode}
    />
    <path
      d="M6.57397 0.5C9.88768 0.5 12.574 3.18629 12.574 6.5H6.57397V0.5Z"
      fill={primaryColorHexCode}
    />
  </svg>
);
